
import { defineComponent } from 'vue';
import { accessor } from '@redviking/argonaut-core-ui/src/store';
import { onClientErrorFallback } from './util/gql-client';
import { Notify } from './notifications';
import { registerServiceWorker } from '@redviking/argonaut-util/src/register-service-worker';
import { useModalRenderer } from './util/composables/useModal';

export default defineComponent({
    name: 'App',
    setup () {
        onClientErrorFallback((error) => {
            Notify.error(error);
        });

        return useModalRenderer();
    },
    async created () {
        if (navigator.serviceWorker) {
            try {
                await registerServiceWorker();
            } catch (err) {
                console.error('Service Worker registration failed', err);
                setTimeout(() => Notify.error('Failed to register service worker, media files will be unavailable'), 2000); // timeout because the notification won't show before the components are mounted
            }
        } else if (location.protocol === 'https:') {
            setTimeout(() => Notify.error('Failed to register service worker, media files will be unavailable'), 2000); // timeout because the notification won't show before the components are mounted
        } else {
            setTimeout(() => Notify.error('HTTPS is required to access media files'), 2000); // timeout because the notification won't show before the components are mounted
        }

        // A "silent" refresh in case already authenticated
        await accessor.auth.refreshToken();
    },
});

